import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "asus_proart_sw_ico_last",
  "use": "asus_proart_sw_ico_last-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"asus_proart_sw_ico_last\"><g id=\"asus_proart_sw_ico_last_asus_proart_sw_ico_arrow_last_page\"><rect width=\"48\" height=\"48\" transform=\"translate(48 48) rotate(-180)\" fill=\"none\" /><path d=\"M31.29,40.71l-16-16a1,1,0,0,1,0-1.42l16-16,1.42,1.42L17.41,24l15.3,15.29Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol